// extracted by mini-css-extract-plugin
export default {"Terms":"Terms_Terms__FKi02","Title":"Terms_Title__3i-7B","ListTitles":"Terms_ListTitles__QTATc","AccordianLists":"Terms_AccordianLists__9QNEC"};